import { iconSportCssClass } from '../../data/utils';
import { isPrematchRoute } from '../../Container';
import Badge from '../Badge';
import Link from '../../router/Link';
import { useParams } from '../../router/Router';
import MenuSportCollapse from './MenuSportCollapse';
import { getSportUrl } from '../../prematch/Prematch';
import { getLabel } from '../../InitData';
import { useFilter } from '../../prematch/by-date/FilterProvider';
import { useState } from 'react';

export default function MenuSportButton(props) {
    const p = useParams();
    const filter = useFilter();
    const data = props.data;
    const [toggled, setToggled] = useState(data.id === p.sportId);

    function close(e) {
        e.stopPropagation();
        setToggled(false);
    }

    if (toggled) {
        return <MenuSportCollapse data={data} close={close} />
    }

    const icon = iconSportCssClass(data.id, data.iconClass);
    const eventsCount = data.eventsCountByFilter?.[filter] ?? data.eventsCount;

    return (
        <Link href={getSportUrl(data)} onClick={() => setToggled(true)} className="c_14">
            <div className={"c_14_1 " + icon}></div>
            <span className="c_14_2">{data.descrizione}</span>
            <div className="c_14_3">
                {isPrematchRoute() && data.isLive &&
                    <Badge desc={getLabel('general.live')} />
                }
                <span className="c_14_3_1">{eventsCount}</span>
            </div>
        </Link>
    );
}
